import tagTester from './_tagTester.js';

export default tagTester('Object');



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.2@underscore/modules/_hasObjectTag.js
// module id = 1547
// module chunks = 106